'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPublishedMessage = undefined;

var _PubNubMessageStatusTypes = require('../../constants/PubNubMessageStatusTypes');

var _buildMessageWithStatus = require('./buildMessageWithStatus');

var buildPublishedMessage = exports.buildPublishedMessage = (0, _buildMessageWithStatus.buildMessageWithStatus)(_PubNubMessageStatusTypes.PUBLISHED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildPublishedMessage.js
// module id = 81
// module chunks = 2 3